import MainService from "@/services/MainService.js";

export default {
    name: "PrincipalPage",
    data() {
        let ss = new MainService();
        return {
            msg: "PrincipalPage",
            ss: ss,
            ajax: {
                "url": ss.indexUsuario(),
                headers: ss.getToken(),
            },
        };
    },
    methods: {
    },
    components: {
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
          this.$router.push('/Login');
        }
    }
};
